export default {
  apiServerUrl: 'https://blonie.devsafi.pl/'
  // apiServerUrl: 'https://pppblonie.pl/'
  // apiServerUrl: 'http://lukstar/blonie/public/'
};
